<template>
  <div class="img-upload-con">
    <div class="preview">
      <img v-if="previewUrl" :src="previewUrl" alt="Uploaded Image" />
      <!-- <a class="small-link delete-link" @click.stop="removeImage">{{ $t('button_delete_one') }}</a> -->
    </div>
    <div class="upload-area" @dragover.prevent @drop.prevent="handleDrop" @click="triggerFileInput">
      <input type="file" ref="fileInput" class="file-input" @change="handleFileSelect" accept="image/*" />
      <div class="placeholder">
        <img src="/public/icons/camera.svg" alt="" />
        <!-- <p class="light">{{ $t('alert_upload_image_here') }}</p> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { useToastStore } from '@/stores/toast';

const toastStore = useToastStore();
const { t } = useI18n();

const emit = defineEmits(['file-selected']);

const props = withDefaults(
  defineProps<{
    initialPreviewUrl: string | null;
  }>(),
  {
    initialPreviewUrl: null,
  }
);

const fileInput = ref<HTMLInputElement | null>(null);
const previewUrl = ref<string | null>(props.initialPreviewUrl);

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file && checkFileVolume(file)) {
    emit('file-selected', file);
  }
};

const checkFileVolume = (file) => {
  if (file) {
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
      toastStore.error(t('error_exceed_image_size'));
      return false;
    }
    return true;
  }
};

const handleDrop = (event) => {
  const file = event.dataTransfer.files[0];
  if (file) {
    handleFileSelect({ target: { files: [file] } });
  }
};

const triggerFileInput = () => {
  if (!fileInput.value) return;
  fileInput.value.click();
};

const removeImage = () => {
  if (fileInput.value) fileInput.value.value = '';
  previewUrl.value = null;
  emit('file-selected', null);
};

watch(
  () => props.initialPreviewUrl,
  (newUrl) => {
    previewUrl.value = newUrl;
  }
);
</script>

<style scoped lang="scss">
.img-upload-con {
  position: relative;
  width: 140px;
  margin: 0 auto;
  .preview {
    width: 140px;
    aspect-ratio: 1/1;
    background: $color-gray-40;
    border-radius: 3rem;
    overflow: hidden;
    border: 1px solid $color-gray-40;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .upload-area {
    position: absolute;
    right: -8px;
    bottom: -8px;
    cursor: pointer;
    .placeholder {
      background: $color-gray-700;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
}

.file-input {
  display: none;
}

.upload-content {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.placeholder {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.icon-plus {
  width: 2rem;
  height: 2rem;
  fill: var(--font-white);
  background-color: var(--surface-primary);
  border-radius: 50%;
}

.delete-link {
  color: var(--error);
  cursor: pointer;
  text-decoration: underline;
}
</style>
